'use client';
import { create } from 'zustand';

interface PublicStore {
  searchQuery: string;
  activeCategory: string;
  setSearchQuery: (q: string) => void;
  setActiveCategory: (c: string) => void;
}

export const usePublicStore = create<PublicStore>((set) => ({
  searchQuery: '',
  activeCategory: 'all',
  setSearchQuery: (q) => set({ searchQuery: q }),
  setActiveCategory: (c) => set({ activeCategory: c }),
}));